import { combineReducers } from "redux";
import { reducer } from "./reducer";
import { contentReducer } from "./contentReducer";
import { notificationReducer } from "./notificationReducer";
import threadsReducer from "./threadSlice";

export default combineReducers({
  reducer,
  contentReducer,
  notifications: notificationReducer,
  threads: threadsReducer,
});
